export default __webpack_public_path__ + "static/report-filter-applied-9fad196c8f626b7cb0369c4be40f80a2.mp4";